import React from 'react';

const SectionDivider = ({ label, type = 'default' }) => {
    // Create an array to repeat the text enough times to fill the screen
    const repeatCount = 20;
    const items = Array(repeatCount).fill(label);
    const lightIcon = '✦';

    return (
        <div className="section-divider-container">
            <div className="marquee-wrapper">
                <div className="marquee-content">
                    {items.map((text, index) => (
                        <div key={index} className="divider-item">
                            <span className="divider-text">{text}</span>
                            <span className="divider-icon">
                                {/* Icons are handled via CSS or we can render both and hide one based on theme */}
                                <span className="icon-light">{lightIcon}</span>
                                <span className="icon-dark">✦</span>
                            </span>
                        </div>
                    ))}
                </div>
                {/* Duplicate for seamless loop */}
                <div className="marquee-content" aria-hidden="true">
                    {items.map((text, index) => (
                        <div key={`dup-${index}`} className="divider-item">
                            <span className="divider-text">{text}</span>
                            <span className="divider-icon">
                                <span className="icon-light">{lightIcon}</span>
                                <span className="icon-dark">✦</span>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SectionDivider;
